import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material';
import { GananciasOcasionalesCasaModalComponent} from '../modales/ganancias-ocasionales/ganancias-ocasionales-casa-modal/ganancias-ocasionales-casa-modal.component';
import { GananciasOcasionalesInmueblesModalComponent } from '../modales/ganancias-ocasionales/ganancias-ocasionales-inmuebles-modal/ganancias-ocasionales-inmuebles-modal.component';
import { GananciasOcasionalesAccionesModalComponent } from '../modales/ganancias-ocasionales/ganancias-ocasionales-acciones-modal/ganancias-ocasionales-acciones-modal.component';
import { GananciasOcasionalesActivosModalComponent } from '../modales/ganancias-ocasionales/ganancias-ocasionales-activos-modal/ganancias-ocasionales-activos-modal.component';
import { GananciasOcasionalesHerenciaModalComponent } from '../modales/ganancias-ocasionales/ganancias-ocasionales-herencia-modal/ganancias-ocasionales-herencia-modal.component';
import { GananciasOcasionalesIndemnizacionModalComponent } from '../modales/ganancias-ocasionales/ganancias-ocasionales-indemnizacion-modal/ganancias-ocasionales-indemnizacion-modal.component';
import { GananciasOcasionalesPremiosModalComponent } from '../modales/ganancias-ocasionales/ganancias-ocasionales-premios-modal/ganancias-ocasionales-premios-modal.component';
import { GananciasOcasionalesPremiosExteriorModalComponent } from '../modales/ganancias-ocasionales/ganancias-ocasionales-premios-exterior-modal/ganancias-ocasionales-premios-exterior-modal.component';
import { GananciasOcasionalesPremiosHipicosModalComponent } from '../modales/ganancias-ocasionales/ganancias-ocasionales-premios-hipicos-modal/ganancias-ocasionales-premios-hipicos-modal.component';
import { GananciasOcasionalesPremiosTitulosModalComponent } from '../modales/ganancias-ocasionales/ganancias-ocasionales-premios-titulos-modal/ganancias-ocasionales-premios-titulos-modal.component';
import { GananciasOcasionalesConcursoNacionalModalComponent } from '../modales/ganancias-ocasionales/ganancias-ocasionales-concurso-nacional-modal/ganancias-ocasionales-concurso-nacional-modal.component';
import { GananciasOcasionalesConcursoExteriorModalComponent } from '../modales/ganancias-ocasionales/ganancias-ocasionales-concurso-exterior-modal/ganancias-ocasionales-concurso-exterior-modal.component';
import { GananciasOcasionalesLiquidacionModalComponent } from '../modales/ganancias-ocasionales/ganancias-ocasionales-liquidacion-exterior-modal/ganancias-ocasionales-liquidacion-modal.component';

import { DDocumento } from '@dian/api-formulario';
import { HandlerComponent, Question } from '../handler-component';
import { DNotificacionServicio } from '@dian-cmp/notificaciones';
import { DOperacionesMatematicasServicio, DTipoOperacionAritmetica } from '@dian-cmp/formulario';
import { MessageObservableService } from '../../../../services/message-observable.service';

const VAL_INDICADOR_COMPLETO="999";//Valor de referencia, si el indicador esta en este valor entonces ya paso todos los steps y el modal esta completo

const questions:Question[] = [
  {question: 'Durante 2022 ¿usted vendió la casa donde vivió y que fue de su propiedad por dos años o más?', field: 'cs_id_750', show:true, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"},
  {question: 'Durante 2022 ¿usted vendió bienes inmuebles diferentes a la casa donde vivió (casas, lotes, fincas, apartamentos) y que fueron de su propiedad por dos años o más?', field: 'cs_id_764', show:false, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"},
  {question: 'Durante 2022 ¿usted vendió acciones o cuotas partes, que fueron de su propiedad por dos años o más?', field: 'cs_id_767', show:false, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"},
  {question: 'Durante 2022 ¿usted vendió bienes (activos fijos) diferentes a los anteriores, que fueron de su propiedad por dos años o más?', field: 'cs_id_786', show:false, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"},
  {question: 'En 2022 ¿usted recibió herencias, donaciones, ingresos por divorcio o por porción conyugal?', field: 'cs_id_770', show:false, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"},
  {question: 'En 2022 ¿usted recibió indemnización por seguro de vida?', field: 'cs_id_691', show:false, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"},
  {question: 'En 2022 ¿usted ganó premios por loterías, rifas, juegos, apuestas o similares?', field: 'cs_id_782', show:false, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"},
  {question: 'En 2022 ¿usted ganó premios por loterías, rifas, juegos, apuestas o similares en el exterior?', field: 'cs_id_693', show:false, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"},
  {question: 'En 2022 ¿usted ganó premios hípicos o caninos?', field: 'cs_id_779', show:false, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"},
  {question: 'En 2022 ¿usted ganó premios por títulos de capitalización?', field: 'cs_id_776', show:false, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"},
  {question: 'En 2022 ¿usted ganó premios en concursos o certámenes nacionales?', field: 'cs_id_696', show:false, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"},
  {question: 'En 2022 ¿usted ganó premios por concursos o certámenes internacionales?', field: 'cs_id_697', show:false, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"},
  {question: '¿Usted tuvo utilidades en liquidación de alguna sociedad de la cual fue socio o partícipe por dos años o más?', field: 'cs_id_773', show:false, nextIfValue:"0", isCompleted:false, resp:"", hasSuggested: "0", totalField: "cs_id_"}
];

@Component({
  selector: 'app-ganancias-ocasionales',
  templateUrl: './ganancias-ocasionales.component.html',
  styleUrls: ['./ganancias-ocasionales.component.css'],
  providers: [
    DNotificacionServicio,
    DOperacionesMatematicasServicio
  ]
})
export class GananciasOcasionalesComponent extends HandlerComponent implements OnInit {

  @Input('model') model: DDocumento = new DDocumento();
  @Input('tablaArt73') tablaArt73:any;
  @Output('isCompleted') isCompleted: EventEmitter<boolean> = new EventEmitter<false>();
  @Output('saveModel') saveModel: EventEmitter<boolean> = new EventEmitter<false>();

  constructor(
    public dutilidades:DOperacionesMatematicasServicio, 
    public dNotificacionServicio: DNotificacionServicio,
    private dialog: MatDialog,
    private _messagesObs: MessageObservableService

  ) { 
    super(questions);
  }

  ngOnInit() {
    this.initilizeQuestionsDesdeModelo(this.model);
    this.validateComponentCompleted();
  }

  validateQuestions(id: number) {
    console.log(id);

  }

  private listenMessagesObs() {
    this._messagesObs.getMessages().subscribe(res => {
     
    });
  }

  initilizeQuestionsDesdeModelo(model){
    for(let i=0; i<questions.length; i++){
      switch(i){
        case 0:
        questions[i].resp = model.doc.cuerpo.cs_id_750  
        questions[i].isCompleted = ((model.doc.cuerpo.cs_id_750 != undefined && model.doc.cuerpo.cs_id_750 =="0") || (this.validateModalCompleted(i)));
        if(questions[i].isCompleted || model.doc.cuerpo.cs_id_750 == "1"){questions[i].show = true;}
          break;
        case 1:
        questions[i].resp = model.doc.cuerpo.cs_id_764  
        questions[i].isCompleted = ((model.doc.cuerpo.cs_id_764 != undefined && model.doc.cuerpo.cs_id_764 =="0") || (this.validateModalCompleted(i)));
        if(questions[i].isCompleted || model.doc.cuerpo.cs_id_764 == "1"){questions[i].show = true;}
          break;
        case 2:
        questions[i].resp = model.doc.cuerpo.cs_id_767  
        questions[i].isCompleted = ((model.doc.cuerpo.cs_id_767 != undefined && model.doc.cuerpo.cs_id_767 =="0") || (this.validateModalCompleted(i)));
        if(questions[i].isCompleted || model.doc.cuerpo.cs_id_767 == "1"){questions[i].show = true;}
          break;
        case 3:
        questions[i].resp = model.doc.cuerpo.cs_id_786  
        questions[i].isCompleted = ((model.doc.cuerpo.cs_id_786 != undefined && model.doc.cuerpo.cs_id_786 =="0") || (this.validateModalCompleted(i)));
        if(questions[i].isCompleted || model.doc.cuerpo.cs_id_786 == "1"){questions[i].show = true;}
          break;
        case 4:
        questions[i].resp = model.doc.cuerpo.cs_id_770  
        questions[i].isCompleted = ((model.doc.cuerpo.cs_id_770 != undefined && model.doc.cuerpo.cs_id_770 =="0") || (this.validateModalCompleted(i)));
        if(questions[i].isCompleted || model.doc.cuerpo.cs_id_770 == "1"){questions[i].show = true;}
          break;
        case 5:
        questions[i].resp = model.doc.cuerpo.cs_id_691  
        questions[i].isCompleted = ((model.doc.cuerpo.cs_id_691 != undefined && model.doc.cuerpo.cs_id_691 =="0") || (this.validateModalCompleted(i)));
        if(questions[i].isCompleted || model.doc.cuerpo.cs_id_691 == "1"){questions[i].show = true;}
          break;
        case 6:
        questions[i].resp = model.doc.cuerpo.cs_id_782  
        questions[i].isCompleted = ((model.doc.cuerpo.cs_id_782 != undefined && model.doc.cuerpo.cs_id_782 =="0") || (this.validateModalCompleted(i)));
        if(questions[i].isCompleted || model.doc.cuerpo.cs_id_782 == "1"){questions[i].show = true;}
          break;
        case 7:
        questions[i].resp = model.doc.cuerpo.cs_id_693  
        questions[i].isCompleted = ((model.doc.cuerpo.cs_id_693 != undefined && model.doc.cuerpo.cs_id_693 =="0") || (this.validateModalCompleted(i)));
        if(questions[i].isCompleted || model.doc.cuerpo.cs_id_693 == "1"){questions[i].show = true;}
          break;
        case 8:
        questions[i].resp = model.doc.cuerpo.cs_id_779  
        questions[i].isCompleted = ((model.doc.cuerpo.cs_id_779 != undefined && model.doc.cuerpo.cs_id_779 =="0") || (this.validateModalCompleted(i)));
        if(questions[i].isCompleted || model.doc.cuerpo.cs_id_779 == "1"){questions[i].show = true;}
          break;
        case 9:
        questions[i].resp = model.doc.cuerpo.cs_id_776  
        questions[i].isCompleted = ((model.doc.cuerpo.cs_id_776 != undefined && model.doc.cuerpo.cs_id_776 =="0") || (this.validateModalCompleted(i)));
        if(questions[i].isCompleted || model.doc.cuerpo.cs_id_776 == "1"){questions[i].show = true;}
          break;
        case 10:
        questions[i].resp = model.doc.cuerpo.cs_id_696  
        questions[i].isCompleted = ((model.doc.cuerpo.cs_id_696 != undefined && model.doc.cuerpo.cs_id_696 =="0") || (this.validateModalCompleted(i)));
        if(questions[i].isCompleted || model.doc.cuerpo.cs_id_696 == "1"){questions[i].show = true;}
          break;
        case 11:
        questions[i].resp = model.doc.cuerpo.cs_id_697  
        questions[i].isCompleted = ((model.doc.cuerpo.cs_id_697 != undefined && model.doc.cuerpo.cs_id_697 =="0") || (this.validateModalCompleted(i)));
        if(questions[i].isCompleted || model.doc.cuerpo.cs_id_697 == "1"){questions[i].show = true;}
          break;
        case 12:
        questions[i].resp = model.doc.cuerpo.cs_id_773  
        questions[i].isCompleted = ((model.doc.cuerpo.cs_id_773 != undefined && model.doc.cuerpo.cs_id_773 =="0") || (this.validateModalCompleted(i)));
        if(questions[i].isCompleted || model.doc.cuerpo.cs_id_773 == "1"){questions[i].show = true;}
          break;
      }
      this.checkNextQuestion(i);
    }
    
  }

  openModal(indexQuestionModal:number) {
    const config = {
      minHeight: '80vh',
      minWidth: '80%',
      disableClose: true,
      data: this.model
    };
    switch (indexQuestionModal) {
      case 0:
        let dialog0 = this.dialog.open(GananciasOcasionalesCasaModalComponent, config);
        dialog0.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog0.componentInstance.tablaArt73 = this.tablaArt73;
        dialog0.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 1:
        
        let dialog1 = this.dialog.open(GananciasOcasionalesInmueblesModalComponent, config);
        dialog1.componentInstance.tablaArt73 = this.tablaArt73;
        dialog1.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog1.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
          console.log(data);
        });
        break;
      case 2:
        let dialog2 = this.dialog.open(GananciasOcasionalesAccionesModalComponent, config);
        dialog2.componentInstance.tablaArt73 = this.tablaArt73;
        //dialog2.componentInstance.tablaArt73 = this.tablaArt73;
        dialog2.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog2.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
          console.log(data);
        });
        break;  
      case 3:
        let dialog3 = this.dialog.open(GananciasOcasionalesActivosModalComponent, config);
        dialog3.componentInstance.tablaArt73 = this.tablaArt73;
        dialog3.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog3.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 4:
        let dialog4 = this.dialog.open(GananciasOcasionalesHerenciaModalComponent, config);
        dialog4.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog4.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 5:
        let dialog5 = this.dialog.open(GananciasOcasionalesIndemnizacionModalComponent, config);
        dialog5.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog5.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 6:
        let dialog6 = this.dialog.open(GananciasOcasionalesPremiosModalComponent, config);
        dialog6.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog6.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
          console.log(data);
        });
        break;
      case 7:
        let dialog7 = this.dialog.open(GananciasOcasionalesPremiosExteriorModalComponent, config);
        dialog7.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog7.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
        });
        break;
      case 8:
        let dialog8 = this.dialog.open(GananciasOcasionalesPremiosHipicosModalComponent, config);
        dialog8.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog8.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
          console.log(data);
        });
        break;
      case 9:
        let dialog9 = this.dialog.open(GananciasOcasionalesPremiosTitulosModalComponent, config);
        dialog9.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog9.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
          console.log(data);
        });
        break;
      case 10:
        let dialog10 = this.dialog.open(GananciasOcasionalesConcursoNacionalModalComponent, config);
        dialog10.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog10.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
          console.log(data);
        });
        break;
      case 11:
        let dialog11 = this.dialog.open(GananciasOcasionalesConcursoExteriorModalComponent, config);
        dialog11.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog11.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
          console.log(data);
        });
        break;
      case 12:
        let dialog12 = this.dialog.open(GananciasOcasionalesLiquidacionModalComponent, config);
        dialog12.componentInstance.saveModel.subscribe(() => {
          this.dependenciaTarjetas(indexQuestionModal);
          this.saveModel.emit(true);
        });
        dialog12.afterClosed().subscribe(data => {
          this.validateModalCompleted(indexQuestionModal);
          console.log(data);
        });
        break;
     
    }
    
    
  }

  protected validateModalCompleted(indexQuestion:number):boolean{
    let isModalComplete:boolean = false;
    switch(indexQuestion){
      case 0://Modal 
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_698, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      case 1://Modal 
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_699, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      case 2://Modal 
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_700, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      case 3://Modal 
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_701, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      case 4://Modal 
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_702, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      case 5://Modal
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_703, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      case 6://Modal
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_704, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      case 7://Modal
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_705, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      case 8://Modal
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_706, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      case 9://Modal
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_707, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      case 10://Modal
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_708, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      case 11://Modal
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_709, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      case 12://Modal
        if( this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.IGUALES, this.model.doc.cuerpo.cs_id_710, VAL_INDICADOR_COMPLETO) ){
          isModalComplete=true;break;
        }
        break;
      
      default:
        break;
    }
    if(isModalComplete){
      questions[indexQuestion].isCompleted = true;
      if(questions.length > indexQuestion+1) questions[indexQuestion + 1].show = true;//Habilitar visibilidad de la siguiente pregunta
    }else{
      questions[indexQuestion].isCompleted = false;
      //if(questions.length > indexQuestion+1) questions[indexQuestion + 1].show = false;
    }
    this.validateComponentCompleted();
    return isModalComplete;
  }
  
  
  protected validateHasModalValues(indexQuestion:number):boolean{
    let hasValues:boolean = false;
    switch(indexQuestion){
      case 0://Modal 
        if(this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_751, "0")){
          hasValues=true;break;
        }
        break;
      case 1://Modal 
        if (this.model.doc.cuerpo.cc_id_178 != undefined && this.model.doc.cuerpo.cc_id_178  != null 
          && this.model.doc.cuerpo.cc_id_178 .length >0){
            hasValues=true;break;
        }
        break;
      case 2://Modal 
        if (this.model.doc.cuerpo.cc_id_221 != undefined && this.model.doc.cuerpo.cc_id_221  != null 
          && this.model.doc.cuerpo.cc_id_221 .length >0){
            hasValues=true;break;
        }
        break;
      case 3://Modal 
        if (this.model.doc.cuerpo.cc_id_353 != undefined && this.model.doc.cuerpo.cc_id_353  != null 
          && this.model.doc.cuerpo.cc_id_353 .length >0){
            hasValues=true;break;
        }
        break;
      case 4://Modal 
        if (this.model.doc.cuerpo.cs_id_680 != undefined && this.model.doc.cuerpo.cs_id_680  != null 
          && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_680, "0")){
            hasValues=true;break;
        }
        break;
      case 5://Modal 
        if (this.model.doc.cuerpo.cs_id_692 != undefined && this.model.doc.cuerpo.cs_id_692  != null 
          && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_692, "0")){
            hasValues=true;break;
        }
        break;
      case 6://Modal
        if (this.model.doc.cuerpo.cs_id_783 != undefined && this.model.doc.cuerpo.cs_id_783  != null 
          && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_783, "0")){
            hasValues=true;break;
        }
        break;
      case 7://Modal
        if (this.model.doc.cuerpo.cs_id_694 != undefined && this.model.doc.cuerpo.cs_id_694  != null 
          && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_694, "0")){
            hasValues=true;break;
        }
        break;
      case 8://Modal
        if (this.model.doc.cuerpo.cs_id_780 != undefined && this.model.doc.cuerpo.cs_id_780  != null 
          && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_780, "0")){
            hasValues=true;break;
        }
        if (this.model.doc.cuerpo.cs_id_781 != undefined && this.model.doc.cuerpo.cs_id_781  != null 
          && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_781, "0")){
            hasValues=true;break;
        }
        break;
     case 9://Modal
        if (this.model.doc.cuerpo.cs_id_696 != undefined && this.model.doc.cuerpo.cs_id_696  != null 
          && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_696, "0")){
            hasValues=true;break;
        }
        break;
      case 10://Modal
        if (this.model.doc.cuerpo.cs_id_365 != undefined && this.model.doc.cuerpo.cs_id_365  != null 
          && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_365, "0")){
            hasValues=true;break;
        }
        break;
      case 11://Modal
        if (this.model.doc.cuerpo.cs_id_366 != undefined && this.model.doc.cuerpo.cs_id_366  != null 
          && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_366, "0")){
            hasValues=true;break;
        }
        break;
      case 12://Modal
        if (this.model.doc.cuerpo.cs_id_774 != undefined && this.model.doc.cuerpo.cs_id_774  != null 
          && this.dutilidades.validacionesNumericas(DTipoOperacionAritmetica.MAYOR_QUE, this.model.doc.cuerpo.cs_id_744, "0")){
            hasValues=true;break;
        }
        break;
      default:
        return false;
    }
    return hasValues;
  }
  protected cleanModalValues(indexQuestionModal:number){
    switch(indexQuestionModal){
      case 0:
        this.model.doc.cuerpo.cs_id_753= "0";
        this.model.doc.cuerpo.cs_id_752= "0";
        this.model.doc.cuerpo.cs_id_751= "0";
        this.model.doc.cuerpo.cs_id_754= "0";
        this.model.doc.cuerpo.cs_id_759= "0";
        this.model.doc.cuerpo.cs_id_760= "0";
        this.model.doc.cuerpo.cs_id_793= null;
        this.model.doc.cuerpo.cs_id_755= "0";
        this.model.doc.cuerpo.cs_id_794= "0";
        this.model.doc.cuerpo.cs_id_795= "0";
        this.model.doc.cuerpo.cs_id_761= null;
        this.model.doc.cuerpo.cs_id_762= "0";
        this.model.doc.cuerpo.cs_id_757= null;
        this.model.doc.cuerpo.cs_id_758= "0";
        this.model.doc.cuerpo.cs_id_763= "0";
        this.model.doc.cuerpo.cs_id_796= "0";
        this.model.doc.cuerpo.cs_id_797= "0";
        this.model.doc.cuerpo.cs_id_698="0";//Indicador de Completo
        break;
      case 1:
        this.model.doc.cuerpo.cs_id_765= "0";
        this.model.doc.cuerpo.cs_id_766="0";	
			  this.model.doc.cuerpo.cs_id_792="0";		
			  this.model.doc.cuerpo.cc_id_711=[];	
			  this.model.doc.cuerpo.cc_id_187=[];	
			  this.model.doc.cuerpo.cc_id_178=[];
			  this.model.doc.cuerpo.cc_id_179=[];		
			  this.model.doc.cuerpo.cc_id_180=[];	
			  this.model.doc.cuerpo.cc_id_186=[];
			  this.model.doc.cuerpo.cc_id_181=[];
			  this.model.doc.cuerpo.cc_id_182=[];	
			  this.model.doc.cuerpo.cc_id_714=[];
			  this.model.doc.cuerpo.cc_id_188=[];		
			  this.model.doc.cuerpo.cc_id_183=[];	
			  this.model.doc.cuerpo.cc_id_185=[];
			  this.model.doc.cuerpo.cc_id_184=[];
			  this.model.doc.cuerpo.cc_id_193=[];	
			  this.model.doc.cuerpo.cc_id_712=[];
        this.model.doc.cuerpo.cs_id_699="0";//Indicador de Completo
        break;
      case 2:
        this.model.doc.cuerpo.cc_id_221 = [];
        this.model.doc.cuerpo.cc_id_191 = [];
        this.model.doc.cuerpo.cc_id_190 = [];
        this.model.doc.cuerpo.cc_id_192 = [];
        this.model.doc.cuerpo.cc_id_194 = [];        
        this.model.doc.cuerpo.cc_id_222 = [];
        this.model.doc.cuerpo.cc_id_195 = [];
        this.model.doc.cuerpo.cc_id_196 = [];
        this.model.doc.cuerpo.cc_id_197 = [];
        this.model.doc.cuerpo.cc_id_189 = [];
        this.model.doc.cuerpo.cc_id_198 = [];
        this.model.doc.cuerpo.cc_id_423 = [];
        this.model.doc.cuerpo.cc_id_790 = [];
        this.model.doc.cuerpo.cc_id_199 = [];
        this.model.doc.cuerpo.cs_id_768 = "0";
        this.model.doc.cuerpo.cs_id_769 = "0";
        this.model.doc.cuerpo.cs_id_791 = "0";
        this.model.doc.cuerpo.cs_id_788 = "0";
        this.model.doc.cuerpo.cs_id_700="0";//Indicador de Completo
        break;  
      case 3:
        this.model.doc.cuerpo.cs_id_786= "0";
        this.model.doc.cuerpo.cs_id_676= "0";
        this.model.doc.cuerpo.cs_id_787= "0";
        this.model.doc.cuerpo.cs_id_789= "0";
        this.model.doc.cuerpo.cc_id_224= [];  
        this.model.doc.cuerpo.cc_id_354= [];  
        this.model.doc.cuerpo.cc_id_353= [];  
        this.model.doc.cuerpo.cc_id_356= [];  
        this.model.doc.cuerpo.cc_id_361= [];  
        this.model.doc.cuerpo.cc_id_357= [];  
        this.model.doc.cuerpo.cc_id_355= [];  
        this.model.doc.cuerpo.cc_id_359= [];  
        this.model.doc.cuerpo.cc_id_360= [];  
        this.model.doc.cuerpo.cc_id_225= [];  
        this.model.doc.cuerpo.cc_id_362= [];  
                
        this.model.doc.cuerpo.cs_id_701="0";//Indicador de Completo
        break;
      case 4:
        this.model.doc.cuerpo.cs_id_680="0";
        this.model.doc.cuerpo.cs_id_681 = null;
        this.model.doc.cuerpo.cs_id_682 = "0";
        this.model.doc.cuerpo.cs_id_662 = "0";
        this.model.doc.cuerpo.cs_id_683 = "0";
        this.model.doc.cuerpo.cs_id_685 = null;
        this.model.doc.cuerpo.cs_id_686 = "0";
        this.model.doc.cuerpo.cs_id_684 = "0";
        this.model.doc.cuerpo.cs_id_687 = "0";
        this.model.doc.cuerpo.cs_id_772 = "0";
        this.model.doc.cuerpo.cs_id_689 = "0";
        this.model.doc.cuerpo.cs_id_384 = "0";
        this.model.doc.cuerpo.cs_id_690 = "0";
        this.model.doc.cuerpo.cs_id_666 = "0";
        this.model.doc.cuerpo.cs_id_364 = "0";

        this.model.doc.cuerpo.cs_id_702="0";//Indicador de Completo
        break;
      case 5:
        this.model.doc.cuerpo.cs_id_692="0";
        this.model.doc.cuerpo.cs_id_810="0";
        this.model.doc.cuerpo.cs_id_703="0";//Indicador de Completo
        break;
      case 6:
        this.model.doc.cuerpo.cs_id_783="0";
        this.model.doc.cuerpo.cs_id_704="0";//Indicador de Completo
        break;
      case 7:
        this.model.doc.cuerpo.cs_id_694="0";
        this.model.doc.cuerpo.cs_id_695="0";
        this.model.doc.cuerpo.cs_id_688="0";
        this.model.doc.cuerpo.cs_id_705="0";//Indicador de Completo
        break;
      case 8:
        this.model.doc.cuerpo.cs_id_780="0";
        this.model.doc.cuerpo.cs_id_781="0";
        this.model.doc.cuerpo.cs_id_344="0";
        this.model.doc.cuerpo.cs_id_706="0";//Indicador de Completo
        break;
      case 9:
        this.model.doc.cuerpo.cs_id_777="0";
        this.model.doc.cuerpo.cs_id_778="0";
        this.model.doc.cuerpo.cs_id_707="0";//Indicador de Completo
        break;
      case 10:
        this.model.doc.cuerpo.cs_id_365="0";
        this.model.doc.cuerpo.cs_id_708="0";//Indicador de Completo
        break;
      case 11:
        this.model.doc.cuerpo.cs_id_366="0";
        this.model.doc.cuerpo.cs_id_367="0";
        this.model.doc.cuerpo.cs_id_369="0";
        this.model.doc.cuerpo.cs_id_709="0";//Indicador de Completo
        break;
      case 12:
        this.model.doc.cuerpo.cs_id_774="0";
        this.model.doc.cuerpo.cs_id_775="0";
        this.model.doc.cuerpo.cs_id_710="0";//Indicador de Completo
        break;
      
    }
    this.dependenciaTarjetas(indexQuestionModal);
    this.saveModel.emit(true);
    console.log(this.model);
  }

  public validateComponentCompleted(): boolean{
    for(let i=0; i < questions.length; i++){
      if(questions[i].isCompleted==false){
        this.isCompleted.emit(false);
        return false;
      }
    }
    this.isCompleted.emit(true);//Componente completo!
    return true;
  }

  changeValue(data: any, index: number) {
    questions[index].resp = data.value.toString();
    this.model.doc.cuerpo[data.field] = data.value.toString();
    if(this.model.doc.cuerpo[data.field] == "0"){
      if(this.validateHasModalValues(index)){
        this.dNotificacionServicio.mostrarDialogoConfirmacion('Mensaje',"Está modificando su respuesta a 'No', pero ya existen datos ingresados para esta pregunta. Si confirma, los datos anteriores serán eliminados. ¿Está seguro de continuar?").afterClosed().subscribe(result => {
          if (result) {
            questions[index].isCompleted = true;
            this.cleanModalValues(index);
            this.validateComponentCompleted();
            this.saveModel.emit(true);
          }else{
            this.model.doc.cuerpo[data.field] == "";
          }
        });
      }else{
        questions[index].isCompleted = true;
        this.cleanModalValues(index);
        this.saveModel.emit(true);
      }
    }else if (this.model.doc.cuerpo[data.field] == "1"){
      questions[index].isCompleted = false;
      this.validateModalCompleted(index);//Valida antes de abrir el modal por si ya lo había completado para que siga mostrandolo completo
      this.openModal(index);
      this.saveModel.emit(true);
      
    }
    this.checkNextQuestion(index);
    this.validateComponentCompleted();
    console.log(data);
    console.log(this.model);
  }
  dependenciaTarjetas(indexQuestionModal:number)
  {
    switch (indexQuestionModal) {
      case 0:
        break;
      case 1:
        break;
      case 2:
        break;  
      case 3:
        break;
      case 4:
        break;
      case 5:
        break;
      case 6:
        break;
      case 7:
        break;
      case 8:
        break;
      case 9:
        break;
      case 10:
        break;
      case 11:
        break;
      case 12:
        break;
     
    }
  }

}



// WEBPACK FOOTER //
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/ganancias-ocasionales/ganancias-ocasionales.component.ts